import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import NotAllowed from "../pages/public/NotAllowed";
import RegisterClinic from "../pages/manager/clinic/RegisterClinic";
import { dispatchMessageSave } from "../store/reducers/messageReducer";
import { dispatchActiveClinicSave } from "../store/reducers/activeClinicReducer";
import { isDefined } from "../auxiliar/formatValidators";

const ProtectedRoute = ({ redirectPath = "/login", requiredPermissions, children }) => {
    const dispatch = useDispatch();

    const auth = useSelector((state) => state.auth);
    const activeClinic = useSelector((state) => state.activeClinic);

    if (process.env.REACT_APP_MAINTENANCE_ONGOING === "true") {
        return <Navigate to={"/maintenance"} replace />;
    }

    if (
        auth?.user_type === "manager" &&
        isDefined(auth?.clinics) &&
        Object.keys(auth?.clinics)?.length === 0
    ) {
        dispatchMessageSave(dispatch, {
            msg: "¡Bienvenido a MiFisio! Registra una clínica para continuar.",
            type: "info",
        });
        return <RegisterClinic />;
    }

    if (!activeClinic?.name && isDefined(auth?.clinics) && Object.keys(auth?.clinics)?.length > 0) {
        const clinicId = Object.keys(auth?.clinics)?.[0];
        dispatchActiveClinicSave(
            dispatch,
            clinicId,
            auth?.clinics[clinicId]?.name,
            auth?.clinics[clinicId]?.status,
        );
    }

    if (activeClinic?.status === "unpaid" && isDefined(activeClinic?.id)) {
        return <Navigate to={`/clinic/${activeClinic?.id}?tab=payment`} replace />;
    }

    if (requiredPermissions.includes(auth?.user_type)) {
        return children;
    }

    if (auth?.user_type === "clinic") {
        return <NotAllowed />;
    }

    return <Navigate to={redirectPath} replace />;
};

export default ProtectedRoute;
